/**
 * Merge updates into existing URLSearchParams — delete keys with empty/undefined values.
 */
export function updateSearchParams(
  prev: URLSearchParams,
  updates: Record<string, string | undefined>,
): URLSearchParams {
  const next = new URLSearchParams(prev);
  for (const [key, value] of Object.entries(updates)) {
    if (value === undefined || value === '') next.delete(key);
    else next.set(key, value);
  }
  return next;
}

/**
 * Garde-fou anti open redirect pour toutes les navigations construites depuis
 * une entrée non fiable (`?redirectTo=`, fragment d'URL, retour SSO front).
 *
 * Refuse :
 * - les URL absolues (`https://evil.tld`, `data:`, `javascript:`) ;
 * - les chemins protocol-relative (`//evil.tld`) ;
 * - tout antislash (`\evil.tld`, `/\evil.tld`) que les navigateurs normalisent
 *   en `/` — c'est le vecteur du bypass CVE-2025-68470 corrigé côté
 *   react-router 7.18.0 ;
 * - les pseudo-schémas glissés après un slash (`/javascript:alert(1)`).
 *
 * Critique côté admin : `redirectTo` est aussi recopié dans l'URL de callback
 * SSO qui transporte l'access token dans le fragment.
 */
export function safeInternalPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  const value = raw.trim();
  if (!value.startsWith('/')) return fallback;
  if (value.startsWith('//')) return fallback;
  if (value.includes('\\')) return fallback;
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(value)) return fallback;
  return value;
}
